export class GenericFilter {
  start_date;
  end_date;
  units_ids;
  month;
  year;
  dismissed;

  constructor(obj) {
    this.setParams(obj);
  }

  setParams(obj) {
    obj = obj || {};
    this.start_date = obj.start_date || this.start_date;
    this.end_date = obj.end_date || this.end_date;
    this.units_ids = obj.units_ids || this.units_ids;
    this.month = obj.month || this.month;
    this.year = obj.year || this.year;
    this.dismissed = obj.dismissed || this.dismissed;
  }

  toGetParamsString(baseUrl) {
    const url = baseUrl.split('?')[0];
    const params = [];

    for (const field of Object.keys(this)) {
      let value = this[field];

      if (value || Array.isArray(value)?.length) {
        if (Array.isArray(value)) {
          value.forEach((v) => {
            params.push(this.buildParam(field, v, true));
          });
        } else {
          params.push(this.buildParam(field, value, false));
        }
      }
    }

    const queryString = params.join('&');
    return queryString ? `${url}?${queryString}` : url;
  }

  buildParam(field, value, isArray = false) {
    const paramValue = field === 'units_ids' ? parseInt(value, 10) : value;
    const encodedKey = encodeURIComponent(field) + (isArray ? '[]' : '');
    return `${encodedKey}=${encodeURIComponent(paramValue)}`;
  }
}
